import { ModalElementContext } from 'contexts/ModalProvider'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import type { FormEventHandler } from 'react'
import React, { useCallback, useContext, useRef } from 'react'
import { useIntl } from 'react-intl'
import OfferCapacityWithAgesSelection from '../Filters/CapacityWithAges/OfferCapacityWithAgesSelection'

interface Props {
  capacities: Array<App.RoomCapacity>
}

function BedbankSidebarFilterCapacity({ capacities }: Props) {
  const intl = useIntl()
  const modalElement = useContext(ModalElementContext)

  const formRef = useRef<HTMLFormElement>(null)

  const onCapacityApply = useCallback<FormEventHandler<HTMLFormElement>>((event) => {
    event.preventDefault()
    if (formRef.current?.reportValidity()) {
      modalElement.resolve()
    }
  }, [modalElement])

  return (
    <form onSubmit={onCapacityApply} ref={formRef}>
      <ModalHeader title={intl.formatMessage({
        id: 'uXitAGpRGg5j_Kv0lP-b',
        defaultMessage: 'Who is going?',
        description: 'Title for capacity selection in bedbank sidebar filter',
      })}
      />
      <ModalBody>
        <OfferCapacityWithAgesSelection capacities={capacities} />
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: intl.formatMessage({
            id: 'm7ntfMFbhxUrAHDvB_h-',
            defaultMessage: 'Confirm',
            description: 'Button to confirm capacity selection in bedbank sidebar filter',
          }),
          type: 'submit',
        }}
      />
    </form>
  )
}

export default BedbankSidebarFilterCapacity
